import React, { useEffect } from "react";
import Modal from "react-modal";
import { customModalStyles } from "../../../_shared/components/Modal/ModalStyles";
import { API, graphqlOperation } from "aws-amplify";
import ReactTooltip from "react-tooltip";
import "./AlertModal.scss";

Modal.setAppElement("#root");

function AlertModal(props) {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const [alertLongbowOverallSignal, setAlertLongbowOverallSignal] =
    React.useState(false);
  const [alertVolatilitySignal, setAlertVolatilitySignal] =
    React.useState(false);
  const [alertMomentum30dFlag, setAlertMomentum30dFlag] = React.useState(false);
  const [alertMomentum90dFlag, setAlertMomentum90dFlag] = React.useState(false);
  const [alertTradingRangeSignal, setAlertTradingRangeSignal] =
    React.useState(false);

  function clickModal() {
    setIsOpen(!modalIsOpen);
  }

  useEffect(() => {
    //Prevents scrolling for subscriptions page when remove tickers modal is active.
    if (modalIsOpen) {
      document.body.style.overflow = "hidden";
    } else document.body.style.overflow = "scroll";
  }, [modalIsOpen]);

  React.useEffect(() => {
    const loadTickerData = async () => {
      setAlertLongbowOverallSignal(
        props.cell.row.original.alert_longbow_overall_signal,
      );
      setAlertTradingRangeSignal(
        props.cell.row.original.alert_trading_range_signal,
      );
      setAlertMomentum30dFlag(props.cell.row.original.alert_momentum_30d_flag);
      setAlertMomentum90dFlag(props.cell.row.original.alert_momentum_90d_flag);
      setAlertVolatilitySignal(props.cell.row.original.alert_volatility_signal);
    };
    loadTickerData();
  }, [props.cell]);

  //Make sure tooltip rebuilds on load.
  React.useEffect(() => {
    ReactTooltip.rebuild();
  }, []);

  const options = [
    {
      title: "Longbow Core Signal",
      key: alertLongbowOverallSignal,
      setKey: setAlertLongbowOverallSignal,
    },
    {
      title: "Trading Range Signal",
      key: alertTradingRangeSignal,
      setKey: setAlertTradingRangeSignal,
    },
    {
      title: "Short Term Momentum",
      key: alertMomentum30dFlag,
      setKey: setAlertMomentum30dFlag,
    },
    {
      title: "Medium Term Momentum",
      key: alertMomentum90dFlag,
      setKey: setAlertMomentum90dFlag,
    },
    {
      title: "Volatility Signal",
      key: alertVolatilitySignal,
      setKey: setAlertVolatilitySignal,
    },
  ];

  const mapOptions = options.map((option, i) => {
    return (
      <div className="option" key={i}>
        <input
          type="checkbox"
          className="checkbox"
          defaultChecked={option.key}
          onClick={async () => {
            option.setKey(!option.key);
          }}
        />
        {option.title}
      </div>
    );
  });

  return (
    <div className="ticker-cell">
      {alertLongbowOverallSignal ||
      alertTradingRangeSignal ||
      alertMomentum30dFlag ||
      alertMomentum90dFlag ||
      alertVolatilitySignal ? (
        <div
          onClick={clickModal}
          style={{
            width: 50,
            borderRadius: 10,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "#75CE41",
            color: "#75CE41",
            paddingLeft: 5,
            paddingRight: 5,
            textAlign: "center",
            marginRight: 10,
          }}
        >
          ✓ Alert
        </div>
      ) : (
        <div
          onClick={clickModal}
          style={{
            width: 50,
            borderRadius: 10,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "#707070",
            paddingLeft: 5,
            paddingRight: 5,
            textAlign: "center",
            marginRight: 10,
          }}
        >
          Alert
        </div>
      )}
      {modalIsOpen ? (
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={clickModal}
          style={customModalStyles}
          contentLabel="Ticker Modal"
        >
          <div
            className="longbow-modal"
            style={{ height: 370, overflowY: "hidden" }}
          >
            <div className="longbow-modal-header">
              Ticker Alert: {props.ticker}
              {props.planInterval === "daily" &&
                props.alertsInterval === "intraday" && (
                  <div
                    className="info-icon"
                    data-tip={`Note: As a Daily Plan subscriber, you will only receive Trading Range Signal updates throughout the day. You can upgrade to an Intraday Plan to receive all 5 signal alerts throughout the day.`}
                    style={{ float: "right" }}
                  >
                    i
                  </div>
                )}
              <i
                onClick={() => {
                  clickModal();
                }}
                className="fas fa-times"
              ></i>
            </div>
            <div className="longbow-modal-content">
              <span style={{ fontSize: "14px", color: "#666666" }}>
                Select for notification when there’s a change in:
              </span>
              <div
                className="longbow-tab-options"
                style={{ height: 200, overflowY: "hidden", marginTop: 18 }}
              >
                {mapOptions}
              </div>
              <div className="longbow-tab-buttons" style={{ marginTop: 0 }}>
                <div
                  className="longbow-button-save"
                  onClick={async () => {
                    await API.graphql(
                      graphqlOperation(`mutation {
                      update_ticker_by_pk(pk_columns: {id: "${props.id}"}, _set: {
                        alert_longbow_overall_signal: ${alertLongbowOverallSignal}, 
                        alert_momentum_30d_flag: ${alertMomentum30dFlag}, 
                        alert_momentum_90d_flag: ${alertMomentum90dFlag}, 
                        alert_trading_range_signal: ${alertTradingRangeSignal}, 
                        alert_volatility_signal: ${alertVolatilitySignal}
                      }) {id}}`),
                    );

                    //Update the user's email and SMS settings if any alerts have been set.
                    if (
                      alertLongbowOverallSignal ||
                      alertTradingRangeSignal ||
                      alertMomentum30dFlag ||
                      alertMomentum90dFlag ||
                      alertVolatilitySignal
                    ) {
                      await API.graphql(
                        graphqlOperation(
                          `mutation {update_users(where: {}, _set: {email_notifications: true, sms_notifications: true}){affected_rows}}`,
                        ),
                      );
                      //Maybe let user know that their notificaiton preferences have been updated and set to true?
                    }
                    clickModal();
                  }}
                >
                  Save
                </div>
                <div
                  className="longbow-button-cancel"
                  onClick={() => {
                    clickModal();
                  }}
                >
                  Cancel
                </div>
              </div>
            </div>
          </div>
          <ReactTooltip
            place="bottom"
            effect="solid"
            offset={{ right: "20%" }}
          />
        </Modal>
      ) : null}
    </div>
  );
}
export default React.memo(AlertModal);
